import React from 'react';
import PropTypes from 'prop-types';

import ResultsFiltersHeader from '../ResultsFiltersHeader';
import ListOfFilters from '../ListOfFilters';

import './FiltersContent.scss';

export default function FiltersContent(props) {
  return (
    <section className="filters-content">
      <ResultsFiltersHeader {...props} />
      <ListOfFilters {...props} />
    </section>
  );
}

FiltersContent.propTypes = {
  dependenciesForLoadFiltersDone: PropTypes.bool.isRequired,
};
